import { Field, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
@ObjectType()
export class StorePaymentDataArgs extends ActionArgs {
  @Field(() => String)
  paymentId: string

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider

  /**
   * The gateway's already-parsed webhook payload for this payment, when the caller already has
   * it (e.g. a checkout-paid webhook, via `parseCheckoutPaidEvent`) — lets the gateway persist
   * the snapshot without an extra round trip back to its own API. Callers that omit it (e.g. the
   * Stripe payment-intent queue) fall back to fetching by `paymentId`.
   */
  @Field(() => GraphQLJSON, { nullable: true })
  raw?: Record<string, any>
}
export interface IStorePaymentData extends IAction<void, StorePaymentDataArgs> {}
